/**
 * Created by mac on 7/12/23
 */

const Dice = function (id, save) {
    cleverapps.EventEmitter.call(this);

    this.id = id;

    this.score = save && save.score || undefined;
    this.chosen = save && save.chosen || false;

    if (this.score) {
        this.addRegularMarks();
    }
};

Dice.prototype = Object.create(cleverapps.EventEmitter.prototype);
Dice.prototype.constructor = Dice;

Dice.prototype.getInfo = function () {
    return {
        score: this.score,
        chosen: this.chosen
    };
};

Dice.prototype.onClick = function () {
    if (this.score) {
        this.setChosen(!this.chosen);
    }

    cleverapps.tutorial.trigger("dice");
    Game.currentGame.counter.trigger();
};

Dice.prototype.setChosen = function (chosen) {
    if (this.chosen !== chosen) {
        this.chosen = chosen;
        this.trigger("changeChosen", chosen);
    }
};

Dice.prototype.roll = function (suggested, cb) {
    const previousScore = this.score ? this.score : this.id + 1;
    this.score = suggested || PseudoRandom.GET().random(1, 6);
    this.addRegularMarks();
    this.trigger("roll", previousScore, cb);
};

Dice.prototype.collectMark = function () {
    if (this.mark === undefined) {
        return;
    }
    this.mark.collect();
    this.mark = undefined;
};

Dice.prototype.addRegularMarks = function () {
    this.mark = undefined;
    if (Game.currentGame.letterMission && this.score === 6) {
        this.mark = new Mark("letter");
    }
};

Dice.prototype.hide = function () {
    this.setChosen(false);
    this.trigger("hide");
};

Dice.prototype.flight = function (slot, callback) {
    this.setChosen(false);
    this.trigger("flight", slot, callback);
};

Dice.prototype.highlight = function (cb) {
    this.trigger("highlight", cb);
};